import { render } from "./bindGoogle.vue?vue&type=template&id=5e853814&scoped=true"
import script from "./bindGoogle.vue?vue&type=script&lang=js"
export * from "./bindGoogle.vue?vue&type=script&lang=js"

import "./bindGoogle.vue?vue&type=style&index=0&id=5e853814&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e853814"]])

export default __exports__